import { formatDate } from "date-fns"
import { downloadCSVfromBase64 } from "../../../../lib/utils"
import { colors } from "../../../../ui/colors"
import { CheckCircleIcon } from "../../../../ui/icons/checkCircle"
import { DownloadIcon } from "../../../../ui/icons/download"
import Button from "../../../../ui/molecules/button"
import { ImportCSVResponseDTO } from "../../dto"
import { useParams } from "react-router-dom"

interface Props {
    importResponse: ImportCSVResponseDTO;
    onClose: () => void;
}

export function ContactMissed(props: Props) {
    const tabValue = useParams().tab;
    return (
        <>
            <CheckCircleIcon color={colors.green[500]} size={64} />
            <span className="text-heading-xs text-neutral-800 font-bold">Importazione completata</span>
            <div className="flex items-center justify-center gap-3">
                <span className="text-text-sm text-neutral-600">Contatti importati: <span className="text-text-sm text-neutral-800 font-semibold">{props.importResponse.successIds.length}</span></span>
                <span className="text-text-sm text-neutral-600">Errori: <span className="text-text-sm text-red-500 font-semibold">{props.importResponse.errors}</span></span>
                <span className="text-text-sm text-neutral-600">Duplicati: <span className="text-text-sm text-red-500 font-semibold">{props.importResponse.duplicates}</span></span>
            </div>
            <Button
                size={"md"}
                iconPosition={"off"}
                variant={"solid"}
                color="green"
                label="Ok"
                onClick={props.onClose}
            />
            <Button
                size={"md"}
                iconPosition={"left"}
                variant={"link"}
                color={"blue"}
                label="Scarica lista contatti non importati"
                icon={<DownloadIcon color={""} size={0} />}
                onClick={() => {
                    downloadCSVfromBase64(props.importResponse.base64CsvMissed!, "cd_missed_" + tabValue + "_download_" + formatDate(new Date(), "dd_MM_yyyy"))
                }}
            />
        </>
    )
}